import React from 'react';

import { Form, Select } from 'antd';
import { WrapperSelect } from 'common/components';
import { useFormatMessage } from 'hooks';

import { REPORTS_DATA_FORMAT } from 'static/Constants';

import Messages from 'i18n/messages/folder';

const { Option } = Select;

const formLayout = { labelCol: { span: 5 }, wrapperCol: { span: 10 } };

const DownloadFolderReportingSetting = () => {
  const messages = useFormatMessage(Messages);

  return (
    <Form.Item
      {...formLayout}
      name='reportingDataFormat'
      label={messages.memberDataFormat}
    >
      <WrapperSelect getPopupContainer={(trigger) => trigger.parentElement}>
        {REPORTS_DATA_FORMAT.map((option, index) => {
          return (
            <Option key={index} value={option}>
              {option?.toUpperCase()}
            </Option>
          );
        })}
      </WrapperSelect>
    </Form.Item>
  );
};

export default DownloadFolderReportingSetting;
